// extracted by mini-css-extract-plugin
module.exports = {"body":"_8dc2ae1","topPadding":"_c4893ce","info":"_0b6cd53","scrollableArea":"_bd20e91","mobileDevice":"_20b5430","ownLine":"_83f68c8","button":"_6d8074f"};